import type { API } from 'chessboard/api/config/types';
import { Core } from 'chessboard/core/config/types';
import type { Game } from 'model/game/types';

/**
 * Create the setTurn method.
 */
export function createSetTurn(context: API.Context) {
  /**
   * Set the color to move.
   */
  return function setTurn(color: Game.ColorsAsNumbers): API.Response {
    const { game, respond } = context;

    if (game.turn() === color) {
      return null;
    }

    game.turn(color);

    return respond(Core.APIEvents.TurnSet, color);
  };
}
